import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'mapm-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent implements OnInit {
  @Input() icon = '';
  @Input() isActiveIcon = '';
  @Input() isActive = false;
  @Input() tooltipText = '';
  @Input() iconClasses = '';
  @Input() containerClasses = '';
  @Input() isMatIcon = false;
  @Input() isTooltipVisible = true;
  @Input() isActiveOnHover = false;
  @Input() showToolTipOnActive = false;
  @Input() showToolTipOnInactive = false;
  @Input() inactiveTooltip = '';

  isHovered = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  onHover(isHoverd: boolean) {
    this.isHovered = isHoverd;
  }

  getIconClasses(): string {
    let result = this.iconClasses;

    if (this.isActive || this.isHovered) {
      result += ` ${this.isActiveIcon}`;
    } else
      result += ` ${this.icon}`;

    return result;
  }

  getContainerClasses(): string {
    let result = this.containerClasses;

    if (this.isActive || this.isHovered)
      result += ' tk-bg-blue';
    else if (!this.isActive || !this.isHovered || !this.isActiveOnHover)
      result += ' bg-white';

    return result;
  }
}
